import 'react';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
var messages = {
  tradeInOnly: /*#__PURE__*/jsxs(Fragment, {
    children: ["Add your Kelley Blue Book", /*#__PURE__*/jsx("sup", {
      children: "\xAE"
    }), " Trade-In Value in My Wallet.", ' ']
  }),
  dealAndTradeIn: 'You have new updates in My Wallet!',
  dealsAndNoTradeIn: 'You have new deal updates in My Wallet!',
  priceChangeFlag: 'The price has changed in your deal.',
  paymentChangeFlag: 'The monthly payment amount has changed in your deal.',
  sellingVehicleChangeFlag: 'The vehicle has changed in your deal.',
  dealTypeChangeFlag: 'The financing option has changed in your deal.',
  creditAppStatusChangeFlag: 'Your credit application status has changed in your deal.',
  // Next steps reminders
  testDrive: 'Waiting to finalize an offer on your dream car?',
  creditApp: 'Save time at the dealership and get pre-approved on your current offer.',
  testDriveAndCreditApp: "Check the progress of your offer and see what's next."
};
export { messages as default };
